import React from 'react';
import { StyleSheet } from 'react-native';
import ReanimatedSwipeable, {
  SwipeableProps as ReanimatedSwipeableProps,
} from 'react-native-gesture-handler/ReanimatedSwipeable';
import Animated, {
  Extrapolation,
  SharedValue,
  interpolate,
  useAnimatedStyle,
} from 'react-native-reanimated';

import { BigButton } from '@components/Button';
import { useAppTheme } from '@context/ThemeContext';

type SwipeableProps = React.PropsWithChildren<ReanimatedSwipeableProps>;

export default function Swipeable(props: SwipeableProps) {
  return <ReanimatedSwipeable {...props} />;
}

type DeleteSwipeableProps = Omit<SwipeableProps, 'renderRightActions'> & {
  loading?: boolean;
  onDelete?: () => void;
};

export function DeleteSwipeable({ loading = false, onDelete, ...props }: DeleteSwipeableProps) {
  const renderRightActions = (_progress: SharedValue<number>, translation: SharedValue<number>) => (
    <DeleteAction loading={loading} onDelete={onDelete} translation={translation} />
  );

  return <Swipeable renderRightActions={renderRightActions} {...props} />;
}

type DeleteActionProps = {
  loading: boolean;
  onDelete?: () => void;
  translation: SharedValue<number>;
};

function DeleteAction({ loading, onDelete, translation }: DeleteActionProps) {
  const appTheme = useAppTheme();

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: interpolate(translation.value, [-50, 0], [1, 0], Extrapolation.CLAMP),
  }));

  return (
    <Animated.View style={[styles.deleteButton, animatedStyle]}>
      <BigButton
        mode="text"
        textColor={appTheme.colors.error}
        onPress={onDelete}
        loading={loading}
        disabled={loading}
        compact>
        Delete
      </BigButton>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  deleteButton: {
    justifyContent: 'center',
    marginLeft: 10,
    padding: 5,
  },
});
